// @core/api/endpoints/workflow/decide_pipeline_run_as_request.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DecidePipelineRunAsRequestRequest,
  PipelineRunAsRequestResponse,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Approve or reject an execution identity request
 * Performs decide operation on pipeline run as request.
 */
export async function DecidePipelineRunAsRequest(
  request_id: string,
  data: DecidePipelineRunAsRequestRequest,
  options?: RequestOptions
): Promise<PipelineRunAsRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/run-as-requests/:request_id/decide`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<PipelineRunAsRequestResponse>(requestPath, data, requestOptions);
}
